module.exports = __webpack_public_path__ + "img/template-bg.781038ca.jpg";